export function isWelcomeFromV1Open({
  paymentProcessor,
  searchParams,
}: {
  paymentProcessor: string | null | undefined;
  searchParams: URLSearchParams;
}) {
  return (
    paymentProcessor !== "shopify" && searchParams.get("welcome") === "true"
  );
}
